// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../css/Theme.bs.js";
import * as React from "react";
import * as UserContext from "../../../auth/user/UserContext.bs.js";
import * as Router from "next/router";
import * as LeftNavigation from "./LeftNavigation.bs.js";
import * as Js_null_undefined from "@rescript/std/lib/es6/js_null_undefined.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.paleGrey),
      tl: {
        hd: BsCss.width(BsCss.pct(100.0)),
        tl: {
          hd: BsCss.display("flex"),
          tl: {
            hd: BsCss.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BsCss.media("(min-width: 1288px)", {
                    hd: BsCss.paddingLeft(BsCss.rem(1.875)),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

function Container(props) {
  var match = UserContext.useUser(undefined);
  var user = match[0];
  var router = Router.useRouter();
  var timer = {
    contents: null
  };
  React.useEffect((function () {
          Js_null_undefined.iter(timer.contents, (function (timer) {
                  clearTimeout(timer);
                }));
          timer.contents = setTimeout((function (param) {
                  if (user) {
                    return ;
                  } else {
                    router.push("/login?redirecturl=" + router.route);
                    return ;
                  }
                }), 100);
          return (function (param) {
                    Js_null_undefined.iter(timer.contents, (function (timer) {
                            clearTimeout(timer);
                          }));
                  });
        }), [user]);
  if (!user) {
    return null;
  }
  var userInfo = user._0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(LeftNavigation.make, {
                      user: userInfo
                    }),
                Curry._1(props.children, userInfo)
              ],
              className: container
            });
}

var make = Container;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
